import { AuthProvider } from "@kalyzee/kast-web-sdk";
import { useCallback, useMemo } from "react";
import Storage, { TokenType } from "../../helpers/storage";
import { Tokens } from "@kalyzee/kast-web-sdk/http";
import { useSdkContext } from "../../contexts/sdk/context";

export const AppAuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const sdkCtx = useSdkContext();
  return (
    <AuthProvider 
      sdk={sdkCtx.client}
      defaultTokens={useMemo(() => {
        const token = Storage.getToken(TokenType.Normal) || undefined;
        const refreshToken = Storage.getToken(TokenType.Refresh) || undefined;
        return token ? { token, refreshToken } : undefined;
      }, [])}
      onTokens={useCallback((tokens?: Tokens) => {
        Storage.setToken(tokens?.token, TokenType.Normal);
        Storage.setToken(tokens?.refreshToken, TokenType.Refresh);
      }, [])}
    > 
      {children}
    </AuthProvider>
  );
}